import { Asset } from "./asset.model";
import { Attachement } from "./attachement.model";
import { RequestActivity } from "./requestactivity.model";

export class Request {
    public id: string;
    public requestNumber: string;
    public createDate: Date;
    public lastUpdateDate: Date;
    public closedDate: Date;
    public requestType: string;
    public status: string;
    public description: string;
    public qualification: string = "";
    public resolution: string;
    public attachments: Attachement[] = []; 
    public pvNumber: string;
    public assetId: string;
    public asset: Asset;
    public externalId: string;
    public externalStatus: string;
    public contactId: string;
    public contact: any; //TODO: change any with contact model
    public contactFirstName: string;
    public contactLastName: string;
    public contactAddress1: string;
    public contactAddress2: string;
    public contactZip: string;
    public contactCity: string;
    public contactCountry: string;
    public contactLanguage: string;
    public contactAdditionalInfo: string;
    public contactPhone1: string;
    public contactEmail: string;
    public contactName: string;
    public companyName: string;
    public companyId: string;
    public company: any; //TODO: change any with company model
    public incidentNumber: number;
    public assetNumber: string;
    public requestActivities: RequestActivity [] = [];
}